/**
 * The discount-ordering rule (FR-032, T176).
 *
 * DECISION: a sale carries AT MOST ONE discount at a time — a promotional
 * percentage off the order, or a statutory Senior Citizen/PWD discount —
 * never both. This is not a simplification of the law; it is the law: RA
 * 9994's implementing regulations treat the statutory discount and a
 * promotional discount as ALTERNATIVES on the same purchase, not amounts
 * that stack. A customer is never entitled to both a 20%-off promo AND the
 * statutory 20%, applied one after the other, on the same items.
 *
 * This also matches the till's own UI (DiscountDialog.tsx already models
 * "the discount in force" as a single `currentRateBp: number | null` slot —
 * applying a new one replaces whatever was there, never adds to it), so
 * extending that same one-slot model to cover the statutory case needed no
 * new interaction pattern, just a second kind of thing that can occupy it.
 *
 * ENFORCEMENT: `priceCart` (price-cart.ts) throws `PricingError` if both
 * `saleDiscount` and `statutoryDiscount` are present in the same
 * `PricingOptions` — see its guard, which imports `DISCOUNT_CONFLICT_MESSAGE`
 * from here so the message and the rule live in the one place. Because
 * "never both" is enforced at the pricing boundary itself, a negative or
 * double-discounted line or total is not a case that has to be tested for —
 * it is a case that cannot be constructed.
 */
export const DISCOUNT_CONFLICT_MESSAGE =
  "A sale may carry a promotional discount or a statutory discount, never both (FR-032)";
